<template>
  <div>
    <div class="filter-container" v-show="!showDetail" >
      <el-radio-group  style=" float: left; margin-left: 20px;"
        v-model="subType"
        v-if="subTypes.length > 0"
        @change="onSearch"
      >
        <el-radio v-for="item in subTypes" :value="item.code" size="large">{{
          item.name
        }}</el-radio>
      </el-radio-group>
<div  :style="'margin-left:20px;float: left;width:'+ ((width >= 600 && subTypes.length > 0) ? 38 : 100 )+'%;'" >
      <el-form-item prop="pCode" label="关键字" >

        <el-input
          clearable
          @keyup.enter.native="getData"
         style="width:65%;"
          class="filter-item"
          placeholder="请输入关键字"
          v-model="keyword"
        >
        </el-input>
        <el-button
          class="filter-item"
          type="primary"
          :icon="Search"
          @click="onSearch"
          >查询</el-button
        >
      </el-form-item>
    </div>
      <el-scrollbar   style="clear: both;">
        <el-table
          :data="datas"
          stripe
          highlight-current-row
          empty-text="暂无数据"
          @current-change="handleRowChange"
        >
          <el-table-column
            prop="title"
            label="标题"
            align="center"
          ></el-table-column>

          <el-table-column
            prop="createTime"
            label="创建时间"
            align="center"
            width="100px"
          ></el-table-column>
        </el-table>
        <div style="margin: 5px" class="PCView">
          <el-pagination
            v-model:current-page="pageIndex"
            v-model:page-size="pageSize"
            :page-sizes="[10, 20, 30, 40]"
            layout="total, sizes, prev, pager, next, jumper"
            :total="recordCount"
            @size-change="pageSizeChange"
            @current-change="handleCurrentChange"
          />
        </div>
        <div style="margin: 5px; text-align: center" class="MView" v-if="showMore">
          <el-button style="width: 80%" type="primary" @click="getData"
            >加载更多...</el-button
          >
        </div>

        <div style="height: 60px"></div>
      </el-scrollbar>
    </div>

    <transition name="el-zoom-in-center">
      <div v-show="showDetail" ref="divDetail">
        <el-page-header
          @back="Return"
          style="height: 40px; line-height: 40px; margin-top: 10px"
          title="详情"
        >
          <template #content>
            <span style="color: #888">{{ data.title }}</span>
          </template>
        </el-page-header>

        <el-scrollbar
          v-infinite-scroll="getData"
          :height="scrHeight - 300 + 'px'"
        >
          <div style="float: right; margin-right: 30px">
            日期:{{ data.createTime }}
          </div>
          <div v-html="data.contents" style="padding: 30px"></div>
          <div style="height: 80px"></div>
        </el-scrollbar>
      </div>
    </transition>
  </div>
</template>
  
     <script  setup>
import {
  ArrowLeft,
  Search,
  CircleCheck,
  Delete,
  Edit,
  CirclePlusFilled,
} from "@element-plus/icons-vue";
import { inject, reactive, ref, watch, onMounted } from "vue";
import { ElMessageBox, ElMessage } from "element-plus";
import {
  post,
  isNull,
  RetrieveLocalData,
  SaveLocalData,
  getOrgCode,
} from "@/api/common"; //常用方法

const global = inject("global");
let _LoginUser = reactive({}); //当前用户

let keyword = ref(""); //查询关键字
let recordCount = ref(0); //总记录数
let datas = ref([]);
let subTypes = ref([]);
let subType = ref(""); //查询关键字
let data = reactive({});
let pageIndex = ref(0); //当前页面
let pageSize = ref(10); //显示记录数
let ownerType = "";
let showMore = ref(false); //显示记录数
let showDetail = ref(false); //是否显示明细编辑
var width = ref(0); //查询关键字
let scrHeight = ref(600); //总记录数
let filter = []; //过滤条件
let orderField = "code"; //排序
let isRetrieving = false; //正在检索
onMounted(() => {
  //页面初始化完成后，调用
  if (!isNull(global.store.state.userInfo))
    _LoginUser = global.store.state.userInfo;

  var oldFilter = RetrieveLocalData("PageInfoFilter");
  if (!isNull(oldFilter)) {
    filter = oldFilter;
    setFilter();
  }
  var oldIndex = RetrieveLocalData("PageInfoPage");
  if (!isNull(oldIndex)) pageIndex.value = oldIndex;
  //获取校验规则
  scrHeight.value = window.screen.height - 85;
  width.value = window.screen.width;
  window.addEventListener("resize", handleResize);
});

//查
const getSubTypes = () => {
  //获取当前页面数据
  const params = {
    custom1: ownerType,
    dictCode: "PageSubType",
    orgCode: getOrgCode(),
  };
  post("base/GetBaseDictByCustom1", params, function (result) {
    if (result.datas == null) subTypes.value = [];
    else subTypes.value = result.datas;

    if (subTypes.length > 0) subType.value = subTypes.values[0].code;
  });
};
function handleResize() {
  scrHeight.value = window.screen.height - 85;
  width.value = window.screen.width;
}
const setFilter = () => {
  filter.forEach((element) => {
    if (element.FieldName == "Name") {
      keyword.value = element.Reference;
    }
  });
};
const pageSizeChange = (val) => {
  pageSize.value = val;
  getData();
};

const getFilter = () => {
  //获取过滤条件
  var filter = [];
  let condition = {};
  condition.FieldName = "OrgCode";
  condition.Opt = "=";
  condition.Value = isNull(_LoginUser.orgCode)
    ? getOrgCode()
    : _LoginUser.orgCode;
  condition.FieldType = "string";

  filter.push(condition);
  if (!isNull(keyword.value)) {
    condition = new Object();
    condition.Opt = "自定义";
    condition.FieldName = "Name";
    condition.Value =
      "keyword like '" + keyword.value + "%' or name like '%" + keyword.value;
    condition.FieldType = "string";
    condition.FieldName;
    filter.push(condition);
  }
  if (!isNull(subType.value)) {
    condition = new Object();
    condition.Opt = "=";
    condition.FieldName = "subType";
    condition.Value = subType.value;
    condition.FieldType = "string";
    condition.FieldName;
    filter.push(condition);
  }

  condition = new Object();
  condition.Opt = "=";
  condition.FieldName = "ownerType";
  condition.Value = ownerType;
  condition.FieldType = "string";
  condition.FieldName;
  filter.push(condition);

  return filter;
};
const setOwnerType = (param) => {
  ownerType = param;

  showDetail.value = false;
  subType.value = "";
  subTypes.value = [];
  getSubTypes();
  onSearch();
};

//查
const getData = () => {
  //获取当前页面数据
  const params = {
    filter: filter,
    pageSize: pageSize.value,
    pageIndex: pageIndex.value,
    orderField: orderField,
  };
  if (isRetrieving) return;
  isRetrieving = true;
  if (pageIndex.value < 0) return;
  isRetrieving = true;
  post("base/GetPageInfo", params, function (result) {
    isRetrieving = false;
    result.datas.forEach((element) => {
      element.createTime = element.createTime.substr(2, 8);
    });
    if (width.value < 600) {
      pageIndex.value = parseInt(pageIndex.value) + 1;
      datas.value = datas.value.concat(result.datas);
      if (result.datas.length == pageSize.value) 
        showMore.value = true;
      else 
        showMore.value = false;
    } else datas.value = result.datas;
  });
};
const onSearch = () => {
  //查询事件
  filter = getFilter();
  const params = {
    filter: filter,
    tableName: "PageInfo",
  };
  pageIndex.value = 0;
  datas.value = [];
  showMore.value = false;

  post("base/GetRecordCount", params, function (result) {
    recordCount.value = result.data;
    RetrieveLocalData("PageInfoFilter", function (oldFilter) {
      if (JSON.stringify(oldFilter) != JSON.stringify(filter)) {
        pageIndex.value = 0;
      }
    });
    SaveLocalData("PageInfoFilter", filter);
    getData();
  });
};
//换行
const handleRowChange = (val) => {
  if (val == null) return;
  Object.assign(data, val);

  showDetail.value = true;
};
//换页
const handleCurrentChange = (val) => {
  pageIndex.value = val - 1; //页面修改
  SaveLocalData("PageInfoPage", pageIndex.value);

  getData();
};

//返回
const Return = () => {
  showDetail.value = false;
};
defineExpose({ setOwnerType });
</script>
    

